import React from 'react';
import FooterComponent from './FooterComponent';
import HeaderComponent from './HeaderComponent';
import LoginPageContent from './LoginForm';
import './index.css';
import LoginHeaderComponent from './LoginHeaderComponent';
const Login = () => {
        return (
            <div className="LoginPage">
                {/* <HeaderComponent /> */}
                <LoginHeaderComponent />
                <LoginPageContent />
                <FooterComponent />
            </div>
        );
}
export default Login;
